
function estados() {
    return new Promise((resolve, reject) => {
      try {
        setTimeout(() => {
          let estados = [];
          estados.push({ id: 0, name: "Todos" });
          estados.push({ id: 1, name: "Pendiente" });
          estados.push({ id: 2, name: "Aprobado" });
          estados.push({ id: 3, name: "Rechazado" });
          estados.push({ id: 4, name: "Pagado" });
  
          resolve({
            data: {
              Error: 0,
              Data: estados,
              Msg: "OK",
            },
          });
        }, 500);
      } catch (error) {
        reject(error);
      }
    });
  }

  function fuentes() {
    return new Promise((resolve, reject) => {
      try {
        setTimeout(() => {
          let fuentes = [];
          fuentes.push({ id: 0, name: "Todos" });
          fuentes.push({ id: 1, name: "SOS" });
          fuentes.push({ id: 2, name: "VT" });
  
          resolve({
            data: {
              Error: 0,
              Data: fuentes,
              Msg: "OK",
            },
          });
        }, 500);
      } catch (error) {
        reject(error);
      }
    });
  }

  export {
    estados,
    fuentes
  }